module.exports = __webpack_public_path__ + "img/bg-01.6552b2c9.png";